type TEditCol = { [key: string]: boolean } | undefined | string;

export const isThereASelectedColumn = (showedColumns: TEditCol): boolean => {
  let atLeastOne = false;
  if (typeof showedColumns === 'string') return true;
  showedColumns &&
    Object.keys(showedColumns).every((key: any) => {
      if (showedColumns[key]) {
        atLeastOne = true;
        return false; // no need to continue loopin through the obj
      }
      return true; //continue looping
    });
  return atLeastOne;
};
